const notificationInitialState = {
  open:        false,
  title:       '',
  description: '',
};

export default notificationInitialState;